<template>
  <div class="pagemain">
    <!-- <div class="head_box">
      <div class="head_left">
        <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />
        <span class="head_title">项目发薪 · 主管初审</span>
      </div>
      <div class="head_right"></div>
    </div> -->
    <!-- <div style="height: 40px"></div> -->

    <div class="tabs_div">
      <Tabs v-model="status" @on-click="tab_change">
        <TabPane :label="'待审核'" name="0"></TabPane>
        <TabPane :label="'已通过'" name="1"></TabPane>
        <TabPane :label="'未通过'" name="2"></TabPane>
        <TabPane :label="'已撤销'" name="3"></TabPane>
      </Tabs>
    </div>
    <div class="query_div">
      <Input size="small" clearable v-model="query_body.payment_id" enter-button style="width: 100px"
        placeholder="输入ID筛选..." />
      <Input size="small" clearable v-model="query_body.query_project_name" enter-button style="width: 100px"
        placeholder="项目名筛选" />
      <Input size="small" clearable v-model="query_body.query_submit_name" enter-button style="width: 100px"
        placeholder="提交人筛选" />
      <Button type="primary" @click="search" size="small" style="font-size:13px">搜索</Button>
      <Button type="error" size="small" style="margin-left: 10px; font-size: 12px"
        v-if="query_body.payment_id">提示：正在筛选，仅显示部分内容，取消后显示全部</Button>
    </div>

    <div class="table_div">
      <Spin v-if="loading" fix>玩命加载中...</Spin>

      <Table :height="windowHeight - 156" :columns="columns" :data="audit_list" size="small" ref="table">
        <template #faxin_file="{ row }">
          <div>
            <span class="down_faxin" @click="down_faxin(row)">
              <Icon type="ios-cloud-download-outline" />发薪表
            </span>
            <span @click="click_faxin_table(row)" class="down_faxin2">
              <Icon type="ios-eye-outline" />查看发放数据
            </span>
          </div>
        </template>
        <template #fujian="{ row }">
          <div>
            <span class="down_faxin" @click="click_fujian(row)">
              <Icon type="ios-eye-outline" />查看附件
            </span>
          </div>
        </template>
        <template #action="{ row }">
          <div class="action_div">
            <Button :disabled="row.zhuguan_audit_fmt != '待审核'" @click="click_audit_btn(row, 1)" size="small"
              type="success" style="margin-right: 5px; font-size: 12px">通过</Button>
            <Button :disabled="row.zhuguan_audit_fmt != '待审核'" @click="click_audit_btn(row, 2)" size="small"
              type="error" style="font-size: 12px">不通过</Button>
          </div>
        </template>

        <template #audit_status_fmt="{ row }">
          <div>
            <Tag v-if="row.is_audit == 1">通过</Tag>
            <Tag v-if="row.is_audit == 2">不通过</Tag>
            <Tag v-if="row.is_audit == 0 && row.is_cancel == 0">待审核</Tag>
            <Tag v-if="row.is_audit == 0 && row.is_cancel == 1" color="error">已撤销</Tag>
          </div>
        </template>
        <template #zhuguan_audit_fmt="{ row }">
          <div>
            <Tag v-if="row.zhuguan_audit_fmt == '通过'" color="success">通过</Tag>
            <Tag v-if="row.zhuguan_audit_fmt == '不通过'" color="error">不通过</Tag>
            <Tag v-if="row.zhuguan_audit_fmt == '待审核'" color="warning">待审核</Tag>
          </div>
        </template>
        <template #is_fafang="{ row }">
          <div>
            <Tag v-if="row.is_fafang == 0">待发放</Tag>
            <Tag v-if="row.is_fafang == 1">已发放</Tag>
            <Tag v-if="row.is_fafang == 2">已撤销</Tag>
          </div>
        </template>
      </Table>
      <div class="page_div">
        <Page :page-size="limit" v-model="page" show-elevator show-total @on-change="page_change"
          :total="total_count" />
      </div>
    </div>

    <Modal v-model="shenpi_show" title="发薪审批" :mask-closable="false" :footer-hide="true" width="350">
      <div class="shenpi_title">
        正在将项目【{{ shenpi_current.project_name }}】审批为【{{
          shenpi_status == 1 ? "通过" : "不通过"
        }}】
      </div>
      <div>
        <Input v-model="shenpi_remarks" placeholder="输入审批备注" style="width: 310px" />
      </div>
      <div class="shenpi_btn">
        <Button type="primary" @click="audit_request">确认审核</Button>
      </div>
    </Modal>

    <Drawer title="附件列表" :closable="true" v-model="fujian_show" width="550">
      <div>
        <div class="fujian_title">图片附件列表</div>
        <Table height="200" :columns="fujian_colunms" :data="img_table" size="small" ref="table">
          <template #url="{ row }">
            <div>
              <a :href="row.url" target="_black">下载文件</a>
            </div>
          </template>
        </Table>
      </div>
      <div>
        <div class="fujian_title">文件附件列表</div>
        <Table height="200" :columns="fujian_colunms" :data="file_table" size="small" ref="table">
          <template #url="{ row }">
            <div>
              <span class="view_file" @click="view_file(row)">
                <Icon type="md-eye" />预览或下载
              </span>
              <!-- <a :href="row.url" target="_black">下载文件</a> -->
            </div>
          </template>
        </Table>
      </div>
    </Drawer>

    <Drawer title="发薪列表1" :closable="true" v-model="faxin_table_show" width="90">
      <div>
        <Table :height="windowHeight - 100" :columns="columns2" :data="table_data2" size="small" ref="table"
          show-summary>
          <template #fafang_status="{ row }">
            <div>
              <Tag color="warning" v-if="row.fafang_status == '待发放'">{{ row.fafang_status }}
              </Tag>
              <Tag color="success" v-if="row.fafang_status == '发放成功'">{{ row.fafang_status }}
              </Tag>
              <Tag color="error" v-if="row.fafang_status == '发放失败'">{{ row.fafang_status }}
              </Tag>
            </div>
          </template>
        </Table>
      </div>
    </Drawer>

  </div>
</template>

<script>
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";
var Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      project_id: "",
      project_name: "",
      audit_list: [],
      columns: [],
      loading: false,

      faxin_table_show: false,
      table_data2: [],
      columns2: [],

      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      fujian_show: false,
      img_table: [],
      file_table: [],
      fujian_colunms: [
        { title: "序号", type: "index", width: 60 },
        { title: "名称", key: "filename" },
        { title: "下载", key: "url", slot: "url", width: 130 },
      ],

      shenpi_show: false,
      shenpi_status: 0,
      shenpi_current: {},
      shenpi_remarks: "",

      total_count: 0,
      limit: 10,
      page: 1,
      status: 0,

      query_body: {
        payment_id: "",
        query_project_name: '',
        query_submit_name:""
      },

    };
  },
  mounted() {
    var query = this.$route.query;
    if (query) {
      this.project_id = query.project_id;
      this.project_name = query.project_name;
    }
    if (query.payment_id) {
      this.query_body.payment_id = query.payment_id;
    }
    this.get_record();
  },

  methods: {
    // handleSummary({ columns, data }) {
    //   console.log(columns);
    //   const sums = {};
    //   for (var i = 0; i < columns.length; i++) {
    //     var type = columns[i]["type"];
    //     var key = columns[i]["key"];
    //     console.log(key)
    //     var slot = columns[i]["slot"];
    //     if (type == "index") {
    //       sums[key] = { key: key, value: "合计" };
    //       continue;
    //     }

    //     if (
    //       key == "money" 
    //     ) {
    //       var total = 0;
    //       console.log(data[x])
    //       for (var x = 0; x < data.length; x++) {
    //         total += parseFloat(data[x][slot]);
    //       }

    //       total = total.toFixed(2);
    //       sums[key] = { key: key, value: total };
    //       continue;
    //     }

    //     var total = 0;
    //     for (var x = 0; x < data.length; x++) {
    //       total += parseFloat(data[x][key]);
    //     }
    //     total = total.toFixed(2);
    //     sums[key] = { key: key, value: total };
    //   }

    //   return sums;
    // },

    updateQueryParam(key, newValue) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set(key, newValue);
      let newUrl =
        window.location.origin + window.location.pathname + "?" + searchParams.toString();
      window.history.pushState({ path: newUrl }, "", newUrl);
    },
    page_change(e) {
      this.page = e;
      this.get_record();
    },

    audit_request() {
      var that = this;

      var obj = {
        payment_id: this.shenpi_current.payment_id,
        status: that.shenpi_status,
        remarks: that.shenpi_remarks,
      };
      http("post", process.env.VUE_APP_HOST + "/finance/payment/faxin_audit", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_record();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_audit_btn(row, status) {
      this.shenpi_current = row;
      this.shenpi_status = status;
      // this.jiezhi_audit_show=true;
      this.shenpi_show = true;
    },

    down_faxin(row) {
      console.log(row);
      get_view_file_url(row.faxin_file_obj);
      //   open_new_page(row.faxin_file);
    },

    view_file(row) {
      get_view_file_url(row.object_name);
    },

    click_fujian(row) {
      this.img_table = row.img_list;
      this.file_table = row.file_list;

      this.fujian_show = true;
    },

    click_faxin_table(row) {
      console.log(row);
      this.get_faxin(row);
      this.faxin_table_show = true;
    },

    get_faxin(row) {
      var that = this;
      var obj = {
        project_id: row.project_id,
        payment_id: row.payment_id,
      };
      http("post", process.env.VUE_APP_HOST + "/finance/payment/faxin_table", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.columns2 = res.data.columns;
            that.table_data2 = res.data.table_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    tab_change(e) {
      this.page = 1;
      this.get_record();
    },

    clear_search() {
      this.updateQueryParam("payment_id", "");
      this.page = 1;
      this.get_record();
    },

    search() {
      this.page = 1;
      this.audit_list = [];
      this.get_record();
    },

    get_record() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        page: this.page,
        status: this.status,
        query_body: this.query_body,
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/payment_submit_audit_record",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.total_count = res.data.total_count;
            that.limit = res.data.limit;
            that.columns = res.data.columns;
            that.audit_list = res.data.audit_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_chexiao(row) {
      var that = this;
      this.$Modal.confirm({
        title: "撤销提示",
        content: "<p>正在撤销，撤销后无法返回，是否继续？</p>",
        onOk: () => {
          that.chexiao_request(row);
        },
        onCancel: () => { },
      });
    },

    chexiao_request(row) {
      var that = this;
      var obj = {
        payment_id: row.payment_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/faxin_revocation",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_record();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>


.view_file {
  font-size: 13px;
  cursor: pointer;
  color: #0466dd;
  margin-right: 10px;
}

.query_div {
  display: flex;
  align-items: center;
  padding: 0 10px 10px 10px;
}

.page_div {
  padding-top: 5px;
  display: flex;
  justify-content: center;
}

.shenpi_btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.shenpi_title {
  text-align: center;
  margin-bottom: 20px;
}

.action_div {
  display: flex;
  align-items: center;
}

.revocation_span {
  color: red;
  cursor: pointer;
}

.fujian_title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin: 10px;
}

.tabs_div {
  display: flex;
  justify-content: center;
}

.pagemain {
  background: #ececec;
  min-height: 100vh;
}

.table_div {
  border-radius: 5px;
  margin: 0 10px;
  position: relative;
  padding: 10px;
  background: #fff;
}

.down_faxin {
  margin-right: 10px;
  color: #0466dd;
  cursor: pointer;
}

.down_faxin2 {
  cursor: pointer;
  color: #0466dd;
}

.down_faxin:hover {
  font-weight: 600;
}

.down_faxin2:hover {
  font-weight: 600;
}

.logo_img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.head_title {
  cursor: pointer;
  letter-spacing: 3px;
  font-size: 13px;
  font-weight: 600;
  color: rgb(255, 255, 255);
}

.head_left {
  display: flex;
  align-items: center;
}

.head_box {
  background: rgb(79, 135, 58);
  height: 40px;
  display: flex;
  z-index: 99;
  width: 100vw;
  position: fixed;
  top: 0;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 20px;
}
</style>
